import React from "react";
import { Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const Logo = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Heading
      variant={"neon"}
      _hover={{ cursor: "pointer" }}
      onClick={() => navigate("/")}
    >
      MP
    </Heading>
  );
};

export default Logo;
